import _regeneratorValues from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/regeneratorValues.js";
import _regenerator from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _createForOfIteratorHelper from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _slicedToArray from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.flat-map.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.map.get-or-insert.js";
import "core-js/modules/es.map.get-or-insert-computed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import * as d3 from "d3";
export default {
  props: {
    barChartRaceData: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  watch: {
    barChartRaceData: function barChartRaceData() {
      if (this.barChartRaceData.length) {
        this.barChartRace();
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    barChartRace: function barChartRace() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var n, k, barSize, margin, height, width, duration, parentDiv, svg, names, datevalues, rank, keyframes, ka, a, kb, b, _iterator, _step, _step$value, _step$value$, _step$value$2, _loop, i, nameframes, prev, next, x, y, formatDate, formatNumber, textTween, bars, labels, ticker, axis, updateBars, updateAxis, updateLabels, updateTicker, wait, _i, _keyframes, keyframe, transition, _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              n = 10;
              k = 1;
              barSize = 84;
              margin = {
                top: 32,
                right: 6,
                bottom: 6,
                left: 0
              };
              height = margin.top + barSize * n + margin.bottom;
              width = 960;
              duration = 2500;
              parentDiv = d3.select("#barChartRace");
              d3.select("#raceSvg").remove();
              svg = parentDiv.append("svg").attr("id", "raceSvg").attr("viewBox", [0, 0, width, height]);
              names = new Set(_this.barChartRaceData.map(function (d) {
                return d.name;
              }));
              datevalues = Array.from(d3.rollup(_this.barChartRaceData, function (_ref) {
                var _ref2 = _slicedToArray(_ref, 1),
                  d = _ref2[0];
                return d.value;
              }, function (d) {
                return d.date;
              }, function (d) {
                return d.name;
              })).map(function (_ref3) {
                var _ref4 = _slicedToArray(_ref3, 2),
                  date = _ref4[0],
                  data = _ref4[1];
                return [new Date(date), data];
              }).sort(function (_ref5, _ref6) {
                var _ref7 = _slicedToArray(_ref5, 1),
                  a = _ref7[0];
                var _ref8 = _slicedToArray(_ref6, 1),
                  b = _ref8[0];
                return d3.ascending(a, b);
              });
              rank = function rank(value) {
                var data = Array.from(names, function (name) {
                  return {
                    name: name,
                    value: value(name)
                  };
                });
                data.sort(function (a, b) {
                  return d3.descending(a.value, b.value);
                });
                for (var i = 0; i < data.length; ++i) data[i].rank = Math.min(n, i);
                return data;
              };
              keyframes = [];
              _iterator = _createForOfIteratorHelper(d3.pairs(datevalues));
              _context3.p = 1;
              _iterator.s();
            case 2:
              if ((_step = _iterator.n()).done) {
                _context3.n = 6;
                break;
              }
              _step$value = _slicedToArray(_step.value, 2);
              _step$value$ = _slicedToArray(_step$value[0], 2);
              ka = _step$value$[0];
              a = _step$value$[1];
              _step$value$2 = _slicedToArray(_step$value[1], 2);
              kb = _step$value$2[0];
              b = _step$value$2[1];
              _loop = /*#__PURE__*/_regenerator().m(function _loop() {
                var t;
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      t = i / k;
                      keyframes.push([new Date(ka * (1 - t) + kb * t), rank(function (name) {
                        return (a.get(name) || 0) * (1 - t) + (b.get(name) || 0) * t;
                      })]);
                    case 1:
                      return _context2.a(2);
                  }
                }, _loop);
              });
              i = 0;
            case 3:
              if (!(i < k)) {
                _context3.n = 5;
                break;
              }
              return _context3.d(_regeneratorValues(_loop()), 4);
            case 4:
              ++i;
              _context3.n = 3;
              break;
            case 5:
              _context3.n = 2;
              break;
            case 6:
              _context3.n = 8;
              break;
            case 7:
              _context3.p = 7;
              _t = _context3.v;
              _iterator.e(_t);
            case 8:
              _context3.p = 8;
              _iterator.f();
              return _context3.f(8);
            case 9:
              keyframes.push([new Date(kb), rank(function (name) {
                return b.get(name) || 0;
              })]);
              nameframes = d3.groups(keyframes.flatMap(function (_ref9) {
                var _ref0 = _slicedToArray(_ref9, 2),
                  data = _ref0[1];
                return data;
              }), function (d) {
                return d.name;
              });
              prev = new Map(nameframes.flatMap(function (_ref1) {
                var _ref10 = _slicedToArray(_ref1, 2),
                  data = _ref10[1];
                return d3.pairs(data, function (a, b) {
                  return [b, a];
                });
              }));
              next = new Map(nameframes.flatMap(function (_ref11) {
                var _ref12 = _slicedToArray(_ref11, 2),
                  data = _ref12[1];
                return d3.pairs(data);
              }));
              x = d3.scaleLinear([0, 1], [margin.left, width - margin.right]);
              y = d3.scaleBand().domain(d3.range(n + 1)).rangeRound([margin.top, margin.top + barSize * (n + 1 + 0.1)]).padding(0.1);
              formatDate = d3.timeFormat("%Y-%m-%d");
              formatNumber = d3.format(",d");
              textTween = function textTween(a, b) {
                var i = d3.interpolateNumber(a, b);
                return function (t) {
                  this.textContent = formatNumber(i(t));
                };
              };
              bars = function bars(svg) {
                var bar = svg.append("g").selectAll("rect");
                return function (_ref13, transition) {
                  var _ref14 = _slicedToArray(_ref13, 2),
                    data = _ref14[1];
                  return bar = bar.data(data.slice(0, n), function (d) {
                    return d.name;
                  }).join(function (enter) {
                    return enter.append("rect").attr("fill", "#0064B5").attr("height", y.bandwidth()).attr("x", x(0)).attr("y", function (d) {
                      return y((prev.get(d) || d).rank);
                    }).attr("width", function (d) {
                      return x((prev.get(d) || d).value) - x(0);
                    });
                  }, function (update) {
                    return update;
                  }, function (exit) {
                    return exit.transition(transition).remove().attr("y", function (d) {
                      return y((next.get(d) || d).rank);
                    }).attr("width", function (d) {
                      return x((next.get(d) || d).value) - x(0);
                    });
                  }).call(function (bar) {
                    return bar.transition(transition).attr("y", function (d) {
                      return y(d.rank);
                    }).attr("width", function (d) {
                      return x(d.value) - x(0);
                    });
                  });
                };
              };
              labels = function labels(svg) {
                var label = svg.append("g").attr("text-anchor", "end").selectAll("text");
                return function (_ref15, transition) {
                  var _ref16 = _slicedToArray(_ref15, 2),
                    data = _ref16[1];
                  return label = label.data(data.slice(0, n), function (d) {
                    return d.name;
                  }).join(function (enter) {
                    return enter.append("text").attr("transform", function (d) {
                      return "translate(".concat(x((prev.get(d) || d).value), ",").concat(y((prev.get(d) || d).rank), ")");
                    }).attr("y", y.bandwidth()).attr("x", -85).attr("dy", "-0.25em").style("font-size", "40px").text(function (d) {
                      return d.name;
                    }).attr("fill", "#ffffff").call(function (text) {
                      return text.append("tspan").attr("fill", "#ffffff").attr("font-weight", "normal").attr("x", -6).attr("dy", "0em").style("font-size", "40px");
                    });
                  }, function (update) {
                    return update;
                  }, function (exit) {
                    return exit.transition(transition).remove().attr("transform", function (d) {
                      return "translate(".concat(x((next.get(d) || d).value), ",").concat(y((next.get(d) || d).rank), ")");
                    }).call(function (g) {
                      return g.select("tspan").tween("text", function (d) {
                        return textTween(d.value, (next.get(d) || d).value);
                      });
                    });
                  }).call(function (bar) {
                    return bar.transition(transition).attr("transform", function (d) {
                      return "translate(".concat(x(d.value), ",").concat(y(d.rank), ")");
                    }).call(function (g) {
                      return g.select("tspan").tween("text", function (d) {
                        return textTween((prev.get(d) || d).value, d.value);
                      });
                    });
                  });
                };
              };
              ticker = function ticker(svg) {
                var now = svg.append("text").style("font-size", "50px").style("font-variant-numeric", "tabular-nums").attr("text-anchor", "end").attr("x", width - 6).attr("y", margin.top + barSize * (n - 0.45)).attr("dy", "0.32em").text(formatDate(keyframes[0][0]));
                return function (_ref17, transition) {
                  var _ref18 = _slicedToArray(_ref17, 1),
                    date = _ref18[0];
                  transition.end().then(function () {
                    return now.text(formatDate(date));
                  });
                };
              };
              axis = function axis(svg) {
                var g = svg.append("g").style("font-size", "40px").attr("transform", "translate(0,".concat(margin.top, ")"));
                return function (_ref19, transition) {
                  var _ref20 = _slicedToArray(_ref19, 2),
                    data = _ref20[1];
                  var max = data[0].value;
                  var axis = d3.axisTop(x).ticks(width / 160 < max ? width / 160 : max) // 6未満の値が最大の時に小数表記になるので、1ずつの区切りにする
                  .tickSizeOuter(0).tickSizeInner(-barSize * (n + y.padding()));
                  g.transition(transition).call(axis);
                  g.select(".tick:first-of-type text").remove();
                  g.selectAll(".tick:not(:first-of-type) line").attr("stroke", "white");
                  g.select(".domain").remove();
                };
              };
              updateBars = bars(svg);
              updateAxis = axis(svg);
              updateLabels = labels(svg);
              updateTicker = ticker(svg);
              wait = /*#__PURE__*/function () {
                var _ref21 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(ms) {
                  return _regenerator().w(function (_context) {
                    while (1) switch (_context.n) {
                      case 0:
                        return _context.a(2, new Promise(function (resolve) {
                          setTimeout(function () {
                            resolve();
                          }, ms);
                        }));
                    }
                  }, _callee);
                }));
                return function wait(_x) {
                  return _ref21.apply(this, arguments);
                };
              }();
              _i = 0, _keyframes = keyframes;
            case 10:
              if (!(_i < _keyframes.length)) {
                _context3.n = 13;
                break;
              }
              keyframe = _keyframes[_i];
              // console.log(keyframe)
              transition = svg.transition().duration(duration).ease(d3.easeLinear); // Extract the top bar’s value.
              x.domain([0, keyframe[1][0].value]);
              updateAxis(keyframe, transition);
              updateBars(keyframe, transition);
              updateLabels(keyframe, transition);
              updateTicker(keyframe, transition);
              _context3.n = 11;
              return transition.end();
            case 11:
              _context3.n = 12;
              return wait(1000);
            case 12:
              _i++;
              _context3.n = 10;
              break;
            case 13:
              return _context3.a(2);
          }
        }, _callee2, null, [[1, 7, 8, 9]]);
      }))();
    }
  }
};